import React, { useEffect, useState,useRef } from "react";
import { useNavigate, Link } from "react-router-dom";
import axios from "axios";
import depositsound from "../assets/notification/deposit.mp3";
import withdrawalsound from "../assets/notification/sound.mp3";
import { toast,ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Swal from "sweetalert2";

const Dashheader = ({ toggleSidebar }) => {
  const navigate = useNavigate();
  const [pendingDeposits, setPendingDeposits] = useState([]);
  const [pendingWithdrawals, setPendingWithdrawals] = useState([]);
  const [userInteracted, setUserInteracted] = useState(false);
  const [chat, setChat] = useState({});
  const isAdmin = localStorage.getItem("isAdmin");
  const depositIdsRef = useRef(new Set());
const withdrawalIdsRef = useRef(new Set());

const userTokened = localStorage.getItem("userToken");
useEffect(() => {

  if (!userTokened  || !isAdmin === "false") {
    navigate("/");
    localStorage.clear();
  }
}, [!isAdmin]);

useEffect(() => {
  const enableSound = () => setUserInteracted(true);

  document.addEventListener("click", enableSound, { once: true });
  document.addEventListener("keydown", enableSound, { once: true });

  return () => {
    document.removeEventListener("click", enableSound);
    document.removeEventListener("keydown", enableSound);
  };
}, []);


// useEffect(() => {
//   const checkAuth = async () => {
//     const token = localStorage.getItem("userToken");

//     if (!token) {
//       Swal.fire("Unauthorized", "Please login first", "warning");
//       localStorage.clear();
//       navigate("/");
//       return;
//     }
//     try {
//       const res = await axios.get("https://sara777chatapi.sindoor7.com/admin/admin-auth-check", {
//         headers: {
//           Authorization: token,
//         },
//       });

//       const dbToken = res.data.user.token;

//       if (res.data.status !== 1 || dbToken !== token) {
//         localStorage.clear();
//         Swal.fire("Unauthorized", "Invalid or expired token", "error");
//         navigate("/");
//       }
//     } catch (error) {
//       console.error("Auth check error:", error);
//       localStorage.clear();
//       Swal.fire("Unauthorized", "Session expired or invalid token", "error");
//       navigate("/");
//     }
//   };

  
//   checkAuth();
// }, [5000]);


const playNotificationSound = (type) => {
  if (!userInteracted) return;

  let soundFile = type === "deposit" ? depositsound : withdrawalsound;
  const audio = new Audio(soundFile);
  audio.play().catch((err) => console.error("Audio play failed:", err));
};

const loadTransactions = async () => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_API_URL}user/transaction-history`);
    const transactions = response.data.transactions || [];

    const newDeposits = transactions.filter((t) => t.type === "Deposit" && t.status === "Pending");
    const newWithdrawals = transactions.filter((t) => t.type === "Withdraw" && t.status === "Pending");

    // Extract IDs
    const newDepositIds = newDeposits.map((t) => t._id);
    const newWithdrawalIds = newWithdrawals.map((t) => t._id);

    const isNewDeposit = newDepositIds.some((id) => !depositIdsRef.current.has(id));
    const isNewWithdrawal = newWithdrawalIds.some((id) => !withdrawalIdsRef.current.has(id));

    console.log("New Deposit:", isNewDeposit);
    console.log("New Withdrawal:", isNewWithdrawal);

    if (isNewDeposit) {
      playNotificationSound("deposit");
      toast.success("New Deposit Received!", {
        position: "top-right",
        autoClose: 9000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    }

    if (isNewWithdrawal) {
      playNotificationSound("withdrawal");
      toast.warning("New Withdrawal Request!", {
        position: "top-right",
        autoClose: 9000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    }

    if (isNewDeposit || isNewWithdrawal) {
      newDepositIds.forEach((id) => depositIdsRef.current.add(id));
      newWithdrawalIds.forEach((id) => withdrawalIdsRef.current.add(id));

      setPendingDeposits(newDeposits);
      setPendingWithdrawals(newWithdrawals);
    }
  } catch (error) {
    console.error("❌ Error fetching transactions:", error);
  }
};


  useEffect(() => {
    loadTransactions();
    const interval = setInterval(loadTransactions, 5000);
    return () => clearInterval(interval);
  }, []);


  const fetchMessages = () => {


    fetch("https://api.Cash365days.in/messagesCount", {
      method: "GET",
    })
      .then((response) => response.json())
      .then((data) => {

        setChat(data);
        console.log(data)
      })
      .catch((error) => {
        console.error("❌ Error fetching messages:", error);
      });
  };

  useEffect(() => {

    fetchMessages();

  }, [isAdmin]);

  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     window.location.reload(); 
  //   }, 30000); 
  
  //   return () => clearInterval(interval); 
  // }, []);
  

  return (
    <>
    <ToastContainer />
    <header className="d-flex justify-content-between fixed-top align-items-center dashheader p-3 shadow bg-light">
      <div className="d-flex gap-2 align-items-center">
        <div className="width_220px">
          <div className="menusection">
            <input type="checkbox" id="menu-toggle" className="menu-checkbox" />
            <label htmlFor="menu-toggle" className="menu-btn" onClick={toggleSidebar}>
              <span></span>
              <span></span>
              <span></span>
            </label>
          </div>
        </div>
      </div>

      <div className="d-flex align-items-center">
        <h4 className="m-0 text-dark">Dashboard</h4>
      </div>

      <div className="d-flex align-items-center new_butttondesign">
       <div className="buttonrefresh">
       <button
          type="button"
          className=" btn-primary position-relative buttondesignnew"
          onClick={() => window.location.reload()}
        >
        {/* <i onClick={() => window.location.reload()} class="bi bi-arrow-clockwise text-dark"></i> */}
        <i class="bi bi-arrow-clockwise text-bold"></i>
        </button>
       </div>

        {/* <Link to="/user" className="buttondesignnew btn-seen position-relative">
          Seen 
          {chat && (
              <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
                {chat.seen}
                </span>
          )}
        </Link> */}
        <Link to="/user" className="buttondesignnew btn-unseen position-relative">
          Unseen 
          {chat && (
              <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
                {chat.unseen}
                </span>
          )}
        </Link>
        <Link to="/deposit" className="buttondesignnew btn-deposit position-relative">
            Deposits
            {pendingDeposits.length > 0 && (
              <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
                {pendingDeposits.length}
              </span>
            )}
        </Link>
        <Link to="/withdraw" className="buttondesignnew btn-withdraws position-relative">
            Withdraws
            {pendingWithdrawals.length > 0 && (
              <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
                {pendingWithdrawals.length}
              </span>
            )}
        </Link>
            <div  className=" buttonlogout buttondesignnew  position-relative">
              
        <a href="void:javascript(0)" type="button" onClick={(e) => { e.preventDefault(); localStorage.clear(); navigate("/"); }}>
          <i className="bi bi-box-arrow-right"></i> Logout
        </a>
            </div>
      </div>
    </header>
    </>
  );
};

export default Dashheader;
